'use strict';

var GridSendFlightReoptButtonDirective = function GridSendFlightReoptButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-send-flight-reopt-button.html'),
    controller: 'GridSendFlightReoptButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', $scope.onRowSelection);
    }
  };
};
GridSendFlightReoptButtonDirective.$inject = [];
module.exports = GridSendFlightReoptButtonDirective;